import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Form from 'react-bootstrap/Form'
import '../../../src/styles/Search.css';
import '../../../src/styles/open-iconic.css';
import '../../../src/styles/open-iconic-bootstrap.css';
import "react-datepicker/dist/react-datepicker.css";
import { solrService } from '../../_services';
import { Document, Page } from "react-pdf";
import MyModal from '../../../src/components/Home/MyModal.jsx';
//import { Modal, ModalManager, Effect } from 'react-dynamic-modal';
import { CSVLink, CSVDownload } from "react-csv";
import { Redirect, Route } from 'react-router-dom'
import { Link } from 'react-router-dom';
import Spinner from '../Spinner';
import Popover from 'react-bootstrap/Popover';
import Overlay from 'react-bootstrap/Overlay';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import DatePicker from "react-datepicker";
import SearchResult from '../Maintenance/SearchResult.jsx'
import queryString from 'query-string';
import ReactGA from 'react-ga';
import DocumentMeta from 'react-document-meta';
import { appService } from '../../_services';

var preSearchParameters = new Object();
let useragent = navigator.userAgent;
//let meta = '';
var FormatSign = {
    display: 'inline-block',
    paddingLeft: '4%',
    marginBottom: '1%'
}

var RemoveFormat = {
    display: 'inline-block',
    marginBottom: '1%'
}

var FormatText = {
    paddingLeft: '4%'
}

export class SearchContent extends Component {
    displayName = SearchContent.name
    csvLink = React.createRef()
    constructor(props) {
        super(props);
        //const { InputText } = props.location.state
        this.state = {
            items: [],
            facetfields: [],
            response: [],
            currentPage: 1,
            itemsPerPage: 25,
            searchparameter: "",
            contResult: "",
            publicationResult: "",
            practiceareaResult: "",
            authorResult: "",
            publicationDateResult: "",
            contentAll: 0,
            publicationAll: 0,
            Last30DCount: 0,
            Last3MCount: 0,
            Last1YCount: 0,
            Last3YCount: 0,
            Last30DChecked: false,
            Last3MChecked: false,
            Last1YChecked: false,
            Last3YChecked: false,
            pubdurAllChecked: false,
            pubdurCPPChecked: false,
            SearchInTitleCount: 0,
            IsselectedDuration: false,
            DisplayWithSummary: true,
            contentWiseSearchParam: "",
            IsAllContent: false,
            parameters: new Object(),
            //preSearchParameters: new Object(),
            Refineparameters: new Object(),
            numPages: null,
            pageNumber: 1,
            show: false,
            SelectedSearchValue: "",
            SelectedPublicationValue: "",
            SelectedAuthorValue: "",
            SelectedPubDurationValue: "",
            SelectedPracticeAreaValue: "",
            SortBy: "",
            ResultCount: "",
            isExisitngSearch: true,
            redirect: false,
            newSearch: false,
            csvData: "",
            csvAllData: [],
            loading: true,
            showPopover: false,
            userName: "",
            ShowDatePicker: false,
            EndDate: "",
            StartDate: "",
            numFound: "",
            DisplayStatus: "Summary",
            Last30DShow: true,
            Last3MShow: true,
            Last1YShow: true,
            Last3YShow: true,
            CPPShow: true,
            AllDateShow: true,
            ExContentType: false,
            ExPublication: false,
            ExAuthor: false,
            ExPubDate: false,
            ExPracticeArea: false,
            metaDescription: '', metaTitle: '',
            CurrentURL: "",
            searchKeywords: "",
            isGAEventSend : false
        };

        this.handleClick = this.handleClick.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handlePrev = this.handlePrev.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
        this.handlePrevPage = this.handlePrevPage.bind(this);
        this.handleFirstPage = this.handleFirstPage.bind(this);
        this.handleLastPage = this.handleLastPage.bind(this);
        this.formatDate = this.formatDate.bind(this);
        this.FindCountForPublicationDateWise = this.FindCountForPublicationDateWise.bind(this);
        this.contentTypeChange = this.contentTypeChange.bind(this);
        this.getContent = this.getContent.bind(this);
        this.getTitle = this.getTitle.bind(this);
        this.SetNumOfRecord = this.SetNumOfRecord.bind(this);
        this.SetSummary = this.SetSummary.bind(this);
        this.SetSorting = this.SetSorting.bind(this);
        this.GetConcatString = this.GetConcatString.bind(this);
        this.handleContentTypeRefineSerach = this.handleContentTypeRefineSerach.bind(this);
        this.handleAuthorRefineSerach = this.handleAuthorRefineSerach.bind(this);
        this.handlePublicationRefineSerach = this.handlePublicationRefineSerach.bind(this);
        this.handlePublicationDurationRefineSerach = this.handlePublicationDurationRefineSerach.bind(this);
        this.handlePracticeAreaRefineSerach = this.handlePracticeAreaRefineSerach.bind(this);
        this.handleSearchWordIntitle = this.handleSearchWordIntitle.bind(this);
        this.SearchAPICall = this.SearchAPICall.bind(this);
        this.searchWithIn = this.searchWithIn.bind(this);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleCPPCheck = this.handleCPPCheck.bind(this);
        //this.showmodal = this.showmodal.bind(this);
        this.DownloadCSV = this.DownloadCSV.bind(this);
        this.CopyURL = this.CopyURL.bind(this);
        this.renderModalPDF = this.renderModalPDF.bind(this);
        //this.showMore = this.showMore.bind(this);        
        this.onDocumentLoadSuccess = ({ numPages }) => {
            this.setState({ numPages });
        };
        this.hidemodal = () => {
            this.setState({ show: false })
        };
    }

    //showmodal(pdfpath,title) {
    //    this.setState({ show: true })
    //    ModalManager.open(<MyModal passParam={pdfpath} titleparam={title} onRequestClose={() => true} />);
    //}

    goToPrevPage = () =>
        this.setState(state => ({ pageNumber: state.pageNumber - 1 }));
    goToNextPage = () =>
        this.setState(state => ({ pageNumber: state.pageNumber + 1 }));

    renderModalPDF = (pdfpath) => {
        return <div>
            <nav>
                <button onClick={this.goToPrevPage}>Prev</button>
                <button onClick={this.goToNextPage}>Next</button>
            </nav>
            <Document
                file={pdfpath}
                onLoadSuccess={this.onDocumentLoadSuccess}
            >
                <Page pageNumber={this.state.pageNumber} />
            </Document>
            <p>Page {this.state.pageNumber} of {this.state.numPages}</p>
        </div>
    }

    HandleSelectedValues(list, oldValue, newValue, separator) {
        //remove old values
        list = list.split(separator);
        var values = oldValue.split(separator);
        for (var i = 0; i < values.length; i++) {
            list = list.filter(e => e !== values[i])
        }
        var removedVal = list.join(separator);
        //join new values
        var str = [removedVal, newValue].filter(Boolean).join(separator);
        return str;
    }

    showMore(tagName, e) {

        if (e.target.innerText == "Show more") {
            e.target.innerText = "Show less";
            var parentNode = this.refs[tagName];
            const node = ReactDOM.findDOMNode(parentNode);
            var checkboxList = node.getElementsByTagName('div');
            Object.keys(checkboxList).map((item, key) => {
                checkboxList[key].className = "square";
            }
            );
        }
        else {
            e.target.innerText = "Show more";
            var parentNode = this.refs[tagName];
            const nodes = ReactDOM.findDOMNode(parentNode);
            var itemsList = nodes.getElementsByTagName('div');
            Object.keys(itemsList).map((item, key) => {
                if (key < 4) {
                    itemsList[key].className = "square";
                }
                else {
                    itemsList[key].className = "hide";
                }
            }
            );
        }

    }

    CopyURL = ({ target }) => {
        var url = window.location.href + "?searchtext=" + this.state.parameters.searchText;
        this.setState({ URLText: url });
        this.setState(s => ({ target, showPopover: !s.showPopover }));
    }

    handleStartDateChange(date) {
        this.setState({
            StartDate: date
        });
        this.state.parameters.PublicationStartDate = date;
        this.state.parameters.PageNo = 1;
        this.setState({
            currentPage: Number(1)
        });
        if (this.state.EndDate != "" && date != "") {
            this.SearchAPICall();
        }
    }

    handleEndDateChange(date) {
        this.setState({
            EndDate: date
        });
        this.state.parameters.PublicationEndDate = date;
        this.state.parameters.PageNo = 1;
        this.setState({
            currentPage: Number(1)
        });
        if (this.state.StartDate != "" && date != "") {
            this.SearchAPICall();
        }
    }

    handleCPPCheck(evt) {
        this.state.parameters.PublicationDuration = "CPP";
        if (evt.target.value === "CPP") {
            this.setState({ pubdurCPPChecked: true });
            this.setState({ ShowDatePicker: true });
        }
        else {
            this.setState({ ShowDatePicker: false });
            this.setState({ pubdurCPPChecked: false });
        }
    }

    DownloadCSV() {
        var csvRecords = [];
        var csv = []
        var self = this;
        var path = 'Search/SearchContent';
        self.setState({ loading: true });
        var param = this.state.parameters;
        param.PageSize = 500;
        param.PageNo = 1;
        solrService.getAll(path, param)
            .then(function (data) {
                self.setState({ loading: false });
                self.setState({ csvAllData: data.item3 });
                self.state.csvAllData.map((item, index) => {
                    {
                        var csvObject = {};
                        csvObject.SrNO = index + 1,
                            csvObject.ISBN = item.isbn,
                            csvObject.Author = item.author != null ? item.author.join(', ') : "",
                            csvObject.Title = item.title != null ? item.title.join(', ') : "",
                            csvObject.publicationDate = item.publicationDate,
                            csvObject.publication = item.publication != null ? item.publication.join(', ') : "",
                            csvObject.practiceArea = item.practiceArea != null ? item.practiceArea.join(', ') : ""
                        csvRecords.push(csvObject);
                    }
                });
                self.setState({ csvData: csvRecords })
                self.csvLink.current.link.click();
                //self.setState({ facetfields: data.item2 });                
            });

    }

    handleSearchWordIntitle(evt) {
        this.state.parameters.AllowSearchInTitle = evt.target.checked;
        this.state.parameters.PageNo = 1;
        this.state.currentPage = 1;
        this.SearchAPICall();
    }

    handleContentTypeRefineSerach() {
        this.state.SelectedSearchValue = this.GetConcatString("ContentType");
    }

    handleAuthorRefineSerach() {
        this.state.SelectedAuthorValue = this.GetConcatString("Author");
    }

    handlePublicationRefineSerach() {
        this.state.SelectedPublicationValue = this.GetConcatString("Publication");
    }

    handlePublicationDurationRefineSerach(evt) {
        if (evt.target.value === "CPP") {
            this.setState({ ShowDatePicker: true });
        }
        else {
            this.state.StartDate = "";
            this.state.EndDate = "";
            this.setState({ ShowDatePicker: false });
        }
        this.state.SelectedPubDurationValue = this.GetConcatString("PublicationDuration", "radio");

    }

    handlePracticeAreaRefineSerach() {
        this.state.SelectedPracticeAreaValue = this.GetConcatString("PracticeArea");
    }

    GetConcatString(tagName, type) {
        var parentNode = this.refs[tagName];
        const node = ReactDOM.findDOMNode(parentNode);
        var checkboxList = node.getElementsByTagName('input');

        const array = [];
        if (checkboxList.length > 0) {
            var result = Object.keys(checkboxList).map((item, key) => {

                if (checkboxList[key].checked) {

                    if (type == "radio") {
                        array.push(checkboxList[key].value);
                    }
                    else {
                        array.push(checkboxList[key].id);
                    }

                }

            })
        }
        else {
            return "";
        }
        if (tagName == "ContentType") {
            this.state.parameters.ContentType = array.join(",");
            this.state.parameters.ExContentType = true;
            this.state.parameters.ExAuthor = false;
            this.state.parameters.ExPubDate = false;
            this.state.parameters.ExPracticeArea = false;
            this.state.parameters.ExPublication = false;
        }
        if (tagName == "Author") {
            this.state.parameters.Author = array.join("##");
            this.state.parameters.ExAuthor = true;
            this.state.parameters.ExContentType = false;
            this.state.parameters.ExPubDate = false;
            this.state.parameters.ExPracticeArea = false;
            this.state.parameters.ExPublication = false;
        }
        if (tagName == "Publication") {
            this.state.parameters.Publication = array.join("##");
            this.state.parameters.ExPublication = true;
            this.state.parameters.ExAuthor = false;
            this.state.parameters.ExContentType = false;
            this.state.parameters.ExPubDate = false;
            this.state.parameters.ExPracticeArea = false;
        }
        if (tagName == "PublicationDuration") {
            this.state.parameters.PublicationDuration = array.toString();
            this.state.parameters.ExPubDate = true;
            this.state.parameters.ExContentType = false;
            this.state.parameters.ExAuthor = false;
            this.state.parameters.ExPracticeArea = false;
            this.state.parameters.ExPublication = false;
        }
        if (tagName == "PracticeArea") {
            this.state.parameters.PracticeArea = array.toString("##");
            this.state.parameters.ExPracticeArea = true;
            this.state.parameters.ExContentType = false;
            this.state.parameters.ExAuthor = false;
            this.state.parameters.ExPubDate = false;
            this.state.parameters.ExPublication = false;
        }

        this.SetSearchValues();

        if (localStorage.getItem('user') !== null) {
            window['NTPT_PGEXTRA'] = 'event_type=Searches_Regular&keywords=' + this.state.searchKeywords + '&user_id=' + localStorage.getItem('salesForceID') + '&User=' + localStorage.getItem('user') + '' + '&platform=klo&useragent=' + useragent;
            const script = document.createElement("script");
            script.src = "/siqpagetag.js";
            script.async = true;
            document.body.appendChild(script);
        }
        else {
            window['NTPT_PGEXTRA'] = 'event_type=Searches_Regular&keywords=' + this.state.searchKeywords + '&platform=klo&useragent=' + useragent;
            const script = document.createElement("script");
            script.src = "/siqpagetag.js";
            script.async = true;
            document.body.appendChild(script);
        }

        this.state.currentPage = 1;
        this.state.parameters.PageNo = 1;
        this.SearchAPICall();
        return array.toString();
    }

    SearchAPICall() {

        var self = this;
        var path = 'Search/SearchContent';
        self.setState({ loading: true });
        solrService.getAll(path, this.state.parameters)
            .then(function (data) {
                self.setState({ items: [] });
                self.setState({ loading: false });
                self.setState({ numFound: data.item4 });
                self.setState({ facetfields: data.item2 });
                self.setState({ response: data.item1 });
                self.setState({ items: data.item3 });
                //self.setState({ facetfields: data.item2 });                
            });

        //ReactGA.initialize(
        //    [
        //        {
        //            trackingId: 'UA-2905701-8',
        //            gaOptions: { name: 'tracker1' }
        //        },
        //        {
        //            trackingId: 'UA-72849501-2',
        //            gaOptions: { name: 'tracker2' }
        //        }
        //    ],
        //    { alwaysSendToDefaultTracker: false }
        //);
        
        ReactGA.pageview(window.location.pathname + window.location.search, ['tracker1', 'tracker2'], "Kluwer Law Online - Search Results");

    }

    searchWithIn(evt) {
        if (evt.target.value == "newsearch") {
            this.setState({ isExisitngSearch: false });
            this.setState({ newSearch: true });
        }
        else {
            this.setState({ isExisitngSearch: true });
        }
    }

    handleClick(event) {
        this.setState({
            currentPage: Number(event.target.id)
        });
    }

    handleNextPage(event) {
        var FirstPage = this.refs["FirstPageDiv"];
        var PrevPage = this.refs["PrevPageDiv"];
        var LastPage = this.refs["LastPageDiv"];
        var NextPage = this.refs["NextPageDiv"];
        FirstPage.className = "col-lg-1";
        PrevPage.className = "col-lg-1";
        event.target.id = this.state.currentPage + 1;
        if (event.target.id == Math.ceil(this.state.numFound / this.state.itemsPerPage)) {
            NextPage.className = "hide";
            LastPage.className = "hide";
        }
        this.setState({
            currentPage: Number(event.target.id)
        });
        this.state.parameters.PageNo = Number(event.target.id);
        this.SearchAPICall();
    }

    handlePrevPage(event) {
        var NextPage = this.refs["NextPageDiv"];
        var LastPage = this.refs["LastPageDiv"];
        var PrevPage = this.refs["PrevPageDiv"];
        var FirstPage = this.refs["FirstPageDiv"];
        NextPage.className = "col-lg-1";
        LastPage.className = "col-lg-1";

        event.target.id = this.state.currentPage - 1;
        if (event.target.id == 1) {
            PrevPage.className = "hide";
            FirstPage.className = "hide";
        }
        this.setState({
            currentPage: Number(event.target.id)
        });
        this.state.parameters.PageNo = Number(event.target.id);
        this.SearchAPICall();
    }

    handleFirstPage(event) {
        event.target.id = 1;
        var PrevPage = this.refs["PrevPageDiv"];
        var FirstPage = this.refs["FirstPageDiv"];
        var NextPage = this.refs["NextPageDiv"];
        var LastPage = this.refs["LastPageDiv"];
        PrevPage.className = "hide";
        FirstPage.className = "hide";
        this.setState({
            currentPage: Number(1)
        });
        if (1 == Math.ceil(this.state.numFound / this.state.itemsPerPage)) {
            NextPage.className = "hide";
            LastPage.className = "hide";
        }
        else {
            NextPage.className = "col-lg-1";
            LastPage.className = "col-lg-1";
        }
        this.state.parameters.PageNo = Number(1);
        this.SearchAPICall();
    }

    handleLastPage(event) {
        var FirstPage = this.refs["FirstPageDiv"];
        var PrevPage = this.refs["PrevPageDiv"];
        var NextPage = this.refs["NextPageDiv"];
        var LastPage = this.refs["LastPageDiv"];
        FirstPage.className = "col-lg-1";
        PrevPage.className = "col-lg-1";
        NextPage.className = "hide";
        LastPage.className = "hide";

        //event.target.id = this.state.currentPage + 1;
        this.setState({
            currentPage: Number(Math.ceil(this.state.numFound / this.state.itemsPerPage))
        });
        this.state.parameters.PageNo = Number(Math.ceil(this.state.numFound / this.state.itemsPerPage));
        this.SearchAPICall();
    }

    handleNext(event) {
        var divElem = this.refs[event.target.id.replace("next", "div")];
        var prevbtn = this.refs[event.target.id.replace("next", "prev")];

        const node = ReactDOM.findDOMNode(divElem);
        var pnode = node.getElementsByTagName('p');
        var hidep = node.getElementsByClassName('searchresultText');

        Object.keys(hidep).map((item, key) => {
            hidep[0].className = "hide";
        });

        var currpage = parseInt(event.target.slot);
        var startIndex = currpage * 2;
        var endIndex = (currpage + 1) * 2;
        event.target.slot = currpage + 1;
        prevbtn.slot = currpage;
        prevbtn.className = "BookBody";
        if (currpage + 1 == Math.ceil(pnode.length / 2)) {
            event.target.className = "hide";
        }
        else {
            event.target.className = "BookBody";
        }
        if (endIndex > pnode.length) {
            endIndex = pnode.length;
            event.target.className = "hide";
        }

        var showp = Object.entries(pnode).slice(startIndex, endIndex);
        Object.keys(showp).map((item, key) => {
            showp[key][1].className = "searchresultText";
        });
    }

    handlePrev(event) {

        var divElem = this.refs[event.target.id.replace("prev", "div")];
        var nextbtn = this.refs[event.target.id.replace("prev", "next")];

        const node = ReactDOM.findDOMNode(divElem);
        var pnode = node.getElementsByTagName('p');
        var hidep = node.getElementsByClassName('searchresultText');

        Object.keys(hidep).map((item, key) => {
            hidep[0].className = "hide";
        });

        var currpage = parseInt(event.target.slot);
        var startIndex = (currpage * 2) - 2;
        var endIndex = currpage * 2;
        event.target.slot = currpage - 1;
        nextbtn.slot = currpage;
        nextbtn.className = "BookBody";

        if (currpage == 1) {
            event.target.className = "hide";
        }
        else {
            event.target.className = "BookBody";
        }

        if (startIndex < 0) {
            startIndex = 0;
        }

        var showp = Object.entries(pnode).slice(startIndex, endIndex);
        Object.keys(showp).map((item, key) => {
            showp[key][1].className = "searchresultText";
        });
    }

    SetNumOfRecord(e) {

        this.setState({ itemsPerPage: e.target.value });
        this.setState({ currentPage: Number(1) });

        var FirstPage = this.refs["FirstPageDiv"];
        var NextPage = this.refs["NextPageDiv"];
        var LastPage = this.refs["LastPageDiv"];
        var PrevPage = this.refs["PrevPageDiv"];
        PrevPage.className = "hide";
        FirstPage.className = "hide";
        if (1 == Math.ceil(Object.values(this.state.numFound).length / this.state.itemsPerPage)) {
            NextPage.className = "hide";
            LastPage.className = "hide";
        }
        else {
            NextPage.className = "col-lg-1";
            LastPage.className = "col-lg-1";
        }
        //this.state.itemsPerPage = e.target.value; 
        this.setState({
            currentPage: Number(1)
        });
        this.state.parameters.PageNo = Number(1);
        this.state.parameters.PageSize = e.target.value;
        this.SearchAPICall();
    }

    SetSummary(e) {
        if (e.target.value == "Summary") {
            this.setState({ DisplayStatus: "Summary" });
            this.setState({ DisplayWithSummary: true });
        }
        else {
            this.setState({ DisplayStatus: "No Summary" });
            this.setState({ DisplayWithSummary: false });
        }
    }

    SetSorting(e) {
        if (e.target.value == "Publication Date") {
            this.setState({ SortBy: "Publication Date" });
            this.state.parameters.SortBy = "publicationdate";
        }
        else {
            this.setState({ SortBy: "Relevancy" });
            this.state.parameters.SortBy = "";
        }
        //this.state.parameters.SortBy = this.state.SortBy;
        this.SearchAPICall();
    }

    getContent(id) {
        let obj = this.state.response[id];
        return obj;
    }

    getTitle(id) {
        let obj = this.state.response[id];
        if (obj.title == undefined)
            return "";
        else
            return obj.title[0];
    }

    formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    FindCountForPublicationDateWise(startDate) {
        var count = 0;
        var endDate = new Date();
        var result = this.state.facetfields.publicationdate.filter(d => {
            return this.formatDate(d.key) >= this.formatDate(startDate) && this.formatDate(d.key) <= this.formatDate(endDate)
        });

        if (result != null && result != 'undefined' && result.length > 0) {

            Object.entries(result).map((item, index) => {
                count = count + item[1].value;
            });
        }
        return count;
    }

    SetSearchValues() {
        this.state.searchKeywords = "";
        this.GetSearchValues(this.state.parameters.searchText);
        this.GetSearchValues(this.state.parameters.ContentType);
        this.GetSearchValues(this.state.parameters.Publication);
        this.GetSearchValues(this.state.parameters.Author);
        this.GetSearchValues(this.state.parameters.PracticeArea);
        this.GetSearchValues(this.state.parameters.PublicationDuration);
        if (this.state.parameters.PublicationDuration == "CPP") {
            this.GetSearchValues(this.state.parameters.PublicationStartDate);
            this.GetSearchValues(this.state.parameters.PublicationEndDate);
        }
    }

    GetSearchValues(paramValue) {
        if (paramValue != null && typeof paramValue != "undefined" && paramValue != "") {           
            var paramval = "";
            if (this.state.searchKeywords) {
                paramval = ";" + paramValue.replace("##", ",");
            }
            else {                
                paramval = paramValue.replace("##", ",");
            }            
            this.state.searchKeywords += paramval;
        }
    }

    componentWillReceiveProps(nextProps) {

        if (this.state.isExisitngSearch) {
            this.setState({ loading: true });
            //this.setState({ parameters.searchText : nextProps.state.searchtext})
            this.state.parameters.searchText = nextProps.state.searchtext;
            this.state.parameters.AllowSearchInTitle = nextProps.state.istitleonly;

            var parameters = { searchText: nextProps.state.searchtext, PageNo: this.state.parameters.PageNo, PageSize: this.state.parameters.PageSize, AllowSearchInTitle: nextProps.state.istitleonly, ContentType: this.props.state.contenttype, Publication: this.props.state.publication, Author: this.props.state.author, PublicationDuration: this.props.state.pubduration, PublicationStartDate: this.props.state.pubstartdate, PublicationEndDate: this.props.state.pubenddate, Mysubscription: this.props.state.searchMySub, ExContentType: this.state.ExContentType, ExPublication: this.state.ExPublication, ExAuthor: this.state.ExAuthor, ExPubDate: this.state.ExPubDate, ExPracticeArea: this.state.ExPracticeArea };
            //Handling values from top to Refine Search
            this.state.parameters.ContentType = this.HandleSelectedValues(this.state.parameters.ContentType, this.props.state.contenttype, nextProps.state.contenttype, ',');
            this.state.parameters.Author = this.HandleSelectedValues(this.state.parameters.Author, this.props.state.author, nextProps.state.author, '##');
            this.state.parameters.Publication = this.HandleSelectedValues(this.state.parameters.Publication, this.props.state.publication, nextProps.state.publication, '##');
            this.state.parameters.Mysubscription = nextProps.state.searchMySub;
            //this.state.parameters.UserName = "";
            //if (nextProps.state.pubduration != "") {
            this.state.parameters.PublicationDuration = nextProps.state.pubduration;
            //}
            var path = 'Search/SearchContent';
            var self = this;
            //preSearchParameters = this.state.parameters;
            Object.assign(preSearchParameters, this.state.parameters);
            solrService.getAll(path, this.state.parameters)
                .then(function (data) {
                    if (Object.values(data.item3).length < 1) {
                        self.setState({ redirect: true });
                    }
                    self.setState({ items: [] });
                    self.setState({ loading: false });
                    self.setState({ numFound: data.item4 });
                    self.setState({ facetfields: data.item2 });
                    self.setState({ response: data.item1 });
                    self.setState({ items: data.item3 });

                });
        }
        if (!this.state.isExisitngSearch) {
            //this.state.parameters = { searchText: this.props.state.searchtext, PageNo: 1, PageSize: 10, AllowSearchInTitle: this.props.state.istitleonly, SortBy: [{}], ContentType: this.props.state.contenttype, Publication: this.props.state.publication, Author: this.props.state.author, PublicationDuration: this.props.state.pubduration, PublicationStartDate: this.props.state.pubstartdate, PublicationEndDate: this.props.state.pubenddate };
            //this.state.parameters.searchText = nextProps.state.searchtext;
            var parameters = { searchText: nextProps.state.searchtext, PageNo: this.state.parameters.PageNo, PageSize: this.state.parameters.PageSize, AllowSearchInTitle: this.props.state.istitleonly, ContentType: this.props.state.contenttype, Publication: this.props.state.publication, Author: this.props.state.author, PublicationDuration: this.props.state.pubduration, PublicationStartDate: this.props.state.pubstartdate, PublicationEndDate: this.props.state.pubenddate };
            var path = 'Search/SearchContent';
            var self = this;

            solrService.getAll(path, parameters)
                .then(function (data) {
                    self.setState({ items: [] });
                    self.setState({ facetfields: data.item2 });
                    self.setState({ response: data.item1 });
                    self.setState({ items: data.item3 });
                    self.setState({ numFound: data.item4 });
                });
        }

        this.SetSearchValues();

        if (localStorage.getItem('user') !== null) {
            window['NTPT_PGEXTRA'] = 'event_type=Searches_Regular&keywords=' + this.state.searchKeywords + '&user_id=' + localStorage.getItem('salesForceID') + '&User=' + localStorage.getItem('user') + '' + '&platform=klo&useragent=' + useragent;
            const script = document.createElement("script");
            script.src = "/siqpagetag.js";
            script.async = true;
            document.body.appendChild(script);
        }
        else {
            window['NTPT_PGEXTRA'] = 'event_type=Searches_Regular&keywords=' + this.state.searchKeywords + '&platform=klo&useragent=' + useragent;
            const script = document.createElement("script");
            script.src = "/siqpagetag.js";
            script.async = true;
            document.body.appendChild(script);
        }

        //GA string 
        //if (this.state.isGAEventSend != true) {

        //    ReactGA.initialize(
        //        [
        //            {
        //                trackingId: 'UA-2905701-8',
        //                gaOptions: { name: 'tracker1' }
        //            },
        //            {
        //                trackingId: 'UA-72849501-2',
        //                gaOptions: { name: 'tracker2' }
        //            }
        //        ],
        //        { alwaysSendToDefaultTracker: false }
        //    );
        
        
        ReactGA.pageview(window.location.pathname + window.location.search, ['tracker1', 'tracker2'], "Kluwer Law Online - Search Results");
            
        //    this.state.isGAEventSend = true;
        //}
        var SIQString = nextProps.state.searchtext;
        SIQString = SIQString.replace('AND', '').replace('OR', '');
        SIQString = SIQString.replace('NOT', '');
        let scripttext = '';
        let options = SIQString.split(' ');
        options.map((itemSearch, index) => {
            if (itemSearch != "") {
                if (index == options.length - 1) {
                    scripttext = scripttext + itemSearch;
                }
                else {
                    scripttext = scripttext + itemSearch + ';';
                }

            }
        });

        //if (localStorage.getItem('user') !== null) {
        //    window['NTPT_PGEXTRA'] = 'event_type=Searches_Regular&keywords=' + scripttext + '&user_id=' + localStorage.getItem('salesForceID') + '&User=' + localStorage.getItem('user') + '' + '&platform=klo &useragent=' + useragent;
        //    const script = document.createElement("script");
        //    script.src = "/siqpagetag.js";
        //    script.async = true;
        //    document.body.appendChild(script);
        //}
        //else {
        //    window['NTPT_PGEXTRA'] = 'event_type=Searches_Regular&keywords=' + scripttext + '&user_id=' + '&platform=klo &useragent=' + useragent;
        //    const script = document.createElement("script");
        //    script.src = "/siqpagetag.js";
        //    script.async = true;
        //    document.body.appendChild(script);

        //}

        //var msg = {
        //    ArticleTitle: window['NTPT_PGEXTRA']
        //}
        //var Logurl = 'Product/LogData';
        //appService.submit(Logurl, msg).then(function (data) {

        //});

        //alert(this.props.state.searchtext + "\r\n    " + this.props.state.contenttype + "\r\n    " + this.props.state.istitleonly + "\r\n    " + this.props.state.publication + "\r\n    " + this.props.state.author + "\r\n    ");
        //this.setState({
        //    searchparameter: nextProps.location.state.GetInputText
        //});
        //alert(nextProps.location.state.GetInputText);        
        //alert(this.props.state.searchtext + "\r\n    " + this.props.state.contenttype + "\r\n    " + this.props.state.istitleonly + "\r\n    " + this.props.state.publication + "\r\n    " + this.props.state.author + "\r\n    " + this.props.state.pubduration + "\r\n    " + this.props.state.pubstartdate + "\r\n    " + this.props.state.pubenddate);
    }

    contentTypeChange(event) {

        //alert(event.target.checked);
        var contype = "journal, manual";
        var author = "";

    }

    componentDidMount() {
        //get logged in userName

        var url = window.location.search;
        var params = queryString.parse(url);
        this.state.CurrentURL = url;

        if (localStorage.getItem('user') !== null) {
            this.state.userName = localStorage.getItem('user').replace("\"", "").replace("\"", "")
        }

        //Handle Pre-filter author search
        if (window['SearchAuthor'] != '' && typeof window['SearchAuthor'] !== "undefined") {
            //this.state.parameters = { searchText: "ert", AllowSearchInTitle: false, SortBy: "", ContentType: "", Publication: "", Author: "", PublicationDuration: "", PublicationStartDate: new Date(), PublicationEndDate: new Date() };
            this.state.parameters = { searchText: this.props.state.searchtext, PageNo: 1, PageSize: 25, AllowSearchInTitle: this.props.state.istitleonly, SortBy: "", ContentType: this.props.state.contenttype, Publication: this.props.state.publication, Author: window['SearchAuthor'], PublicationDuration: this.props.state.pubduration, PublicationStartDate: this.props.state.pubstartdate, PublicationEndDate: this.props.state.pubenddate, Mysubscription: this.props.state.searchMySub, UserName: this.state.userName };
            window['SearchAuthor'] = '';
        }
        else if (this.props.state.btnSearch != true) {
            var parampublicationStartDate = "", parampublicationEndDate ="";
            var paramsearchText = "searchText" in params ? params.searchText : "";
            var paramcontentType = "contentType" in params ? params.contentType : "";
            var parampublication = "publication" in params ? params.publication : "";
            var paramshowwordstitle = "showwordstitle" in params ? params.showwordstitle : false;
            var paramauthorString = "authorString" in params ? params.authorString : "";
            var parampublicationDateString = "publicationDateString" in params ? params.publicationDateString : "";
            if (parampublicationDateString == "CPP") {
                parampublicationStartDate = new Date(params.publicationStartDate);
                parampublicationEndDate = new Date(params.publicationEndDate);
            }
            else {
                parampublicationStartDate = new Date();
                parampublicationEndDate = new Date();
            }
            var paramSubscriptionchecked = "Subscriptionchecked" in params ? params.Subscriptionchecked : false;
            
            this.state.parameters = { searchText: paramsearchText, PageNo: 1, PageSize: 25, AllowSearchInTitle: paramshowwordstitle, SortBy: "", ContentType: paramcontentType, Publication: parampublication, Author: paramauthorString, PublicationDuration: parampublicationDateString, PublicationStartDate: parampublicationStartDate, PublicationEndDate: parampublicationEndDate, Mysubscription: paramSubscriptionchecked, UserName: this.state.userName };
            this.GetSearchValues(paramsearchText);
            this.GetSearchValues(paramcontentType);
            this.GetSearchValues(parampublication);
            this.GetSearchValues(paramshowwordstitle);
            this.GetSearchValues(paramauthorString);
            this.GetSearchValues(parampublicationDateString);
            if (parampublicationDateString == "CPP") {
                this.GetSearchValues(params.publicationStartDate);
                this.GetSearchValues(params.publicationEndDate);
            }            
        }
        else {
            this.state.parameters = { searchText: this.props.state.searchtext, PageNo: 1, PageSize: 25, AllowSearchInTitle: this.props.state.istitleonly, SortBy: "", ContentType: this.props.state.contenttype, Publication: this.props.state.publication, Author: this.props.state.author, PublicationDuration: this.props.state.pubduration, PublicationStartDate: this.props.state.pubstartdate, PublicationEndDate: this.props.state.pubenddate, Mysubscription: this.props.state.searchMySub, UserName: this.state.userName };
            
            this.SetSearchValues();
        }
        preSearchParameters = { searchText: this.props.state.searchtext, PageNo: 1, PageSize: 25, AllowSearchInTitle: this.props.state.istitleonly, SortBy: "", ContentType: this.props.state.contenttype, Publication: this.props.state.publication, Author: this.props.state.author, PublicationDuration: this.props.state.pubduration, PublicationStartDate: this.props.state.pubstartdate, PublicationEndDate: this.props.state.pubenddate, Mysubscription: this.props.state.searchMySub, UserName: this.state.userName };
        //handle Existing search  - Not needed
        if (this.state.isExisitngSearch) {
            //alert(this.state.isExisitngSearch);
            this.state.Refineparameters = { searchText: this.props.state.searchtext, PageNo: 1, PageSize: 25, AllowSearchInTitle: this.props.state.istitleonly, SortBy: "", ContentType: this.props.state.contenttype, Publication: this.props.state.publication, Author: this.props.state.author, PublicationDuration: this.props.state.pubduration, PublicationStartDate: this.props.state.pubstartdate, PublicationEndDate: this.props.state.pubenddate, Mysubscription: this.props.state.searchMySub, UserName: this.state.userName };
        }
        //var parameters = { searchText: this.props.state.searchtext, PageNo: 1, PageSize: 10, AllowSearchInTitle: this.props.state.istitleonly, SortBy: "", ContentType: this.props.state.contenttype, Publication: this.props.state.publication, Author: this.props.state.author, PublicationDuration: this.props.state.pubduration, PublicationStartDate: this.props.state.pubstartdate, PublicationEndDate: this.props.state.pubenddate, Mysubscription: this.props.state.searchMySub, UserName: "" };
        var path = 'Search/SearchContent';
        var self = this;

        solrService.getAll(path, self.state.parameters)
            .then(function (data) {
                if (Object.values(data.item3).length < 1) {
                    self.setState({ redirect: true });
                }
                self.setState({ loading: false });
                self.setState({ numFound: data.item4 });
                self.setState({ facetfields: data.item2 });
                self.setState({ response: data.item1 });
                self.setState({ items: data.item3 });

            });

        var SIQString = this.props.state.searchtext;
        SIQString = SIQString.replace('AND', '').replace('OR', '');
        SIQString = SIQString.replace('NOT', '');

        let options = SIQString.split(' ');
        let scripttext = '';
        options.map((itemSearch, index) => {
            if (itemSearch != "") {
                if (index == options.length - 1) {
                    scripttext = scripttext + itemSearch;
                }
                else {
                    scripttext = scripttext + itemSearch + ';';
                }

            }
        });


        if (localStorage.getItem('user') !== null) {
            window['NTPT_PGEXTRA'] = 'event_type=Searches_Regular&keywords=' + this.state.searchKeywords + '&user_id=' + localStorage.getItem('salesForceID') + '&User=' + localStorage.getItem('user') + '' + '&platform=klo&useragent=' + useragent;
            const script = document.createElement("script");
            script.src = "/siqpagetag.js";
            script.async = true;
            document.body.appendChild(script);
        }
        else {
            window['NTPT_PGEXTRA'] = 'event_type=Searches_Regular&keywords=' + this.state.searchKeywords + '&platform=klo&useragent=' + useragent;
            const script = document.createElement("script");
            script.src = "/siqpagetag.js";
            script.async = true;
            document.body.appendChild(script);
        }        

            ReactGA.initialize(
                [
                    {
                        trackingId: 'UA-2905701-8',
                        gaOptions: { name: 'tracker1' }
                    },
                    {
                        trackingId: 'UA-72849501-2',
                        gaOptions: { name: 'tracker2' }
                    }
                ],
                { alwaysSendToDefaultTracker: false }
        );


        ReactGA.pageview(window.location.pathname + window.location.search, ['tracker1', 'tracker2'], "Kluwer Law Online - Search Results");
          
        //if (localStorage.getItem('user') !== null) {
        //    window['NTPT_PGEXTRA'] = 'event_type=Searches_Regular&keywords=' + scripttext + '&user_id=' + localStorage.getItem('salesForceID') + '&User=' + localStorage.getItem('user') + '' + '&platform=klo &useragent=' + useragent;
        //    const script = document.createElement("script");
        //    script.src = "/siqpagetag.js";
        //    script.async = true;
        //    document.body.appendChild(script);
        //}
        //else {
        //    window['NTPT_PGEXTRA'] = 'event_type=Searches_Regular&keywords=' + scripttext + '&user_id=' + '&platform=klo &useragent=' + useragent;
        //    const script = document.createElement("script");
        //    script.src = "/siqpagetag.js";
        //    script.async = true;
        //    document.body.appendChild(script);

        //}

    }

    render() {

        const meta = {
            title: "Kluwer Law Online - Search Results",
            // description: this.state.metaDescription,
            canonical: window.location.href,
            //meta: {
            //    charset: "utf-8",
            //    name: {
            //        title: this.state.metaTitle,
            //        description: this.state.metaDescription
            //    }
            //}
        }

        var metas = document.getElementsByTagName('meta');
        for (let i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute('name') == "robots") {
                console.log(metas[i]);
                metas[i].remove();
            }
        }

        if (this.state.redirect) {
            let dispText = this.state.parameters.searchText.replace(/ AND /g, "##AND##").replace(/ OR /g, "##OR##").replace(/ NOT /g, "##NOT##").replace(/AND /g, "AND##").replace(/OR /g, "OR##").replace(/NOT /g, "NOT##");
            dispText = dispText.includes('"') ? dispText : dispText.replace(/ /g, " AND ");
            dispText = dispText.replace(/##AND##/g, ' AND ').replace(/##OR##/g, ' OR ').replace(/##NOT##/g, ' NOT ').replace(/AND##/g, 'AND ').replace(/OR##/g, 'OR ').replace(/NOT##/g, 'NOT ');

            return <Redirect to={"/SearchResult" + this.state.CurrentURL } />
        }
        if (this.state.newSearch) {
            return <Redirect to="/" />
        }

        if (this.state.loading) {
            return <Spinner />
        }
        else {

            const images = require.context('../../../src/PDFFiles', true)
            const pdfPath = (name) => images(name, true)
            const { items, currentPage, itemsPerPage, facetfields, numFound } = this.state;
            const csvelement = (<CSVDownload data={this.state.items} target="_blank" />);
            //alert('Searching : ' + JSON.stringify(this.props.state));
            const { pageNumber, numPages } = this.state;
            /// Logic for displaying current items per page ///
            const indexOfLastItem = itemsPerPage;
            const indexOfFirstItem = indexOfLastItem - itemsPerPage;
            const currentItems = Object.entries(items).slice(indexOfFirstItem, indexOfLastItem);

            let dispText = this.state.parameters.searchText.replace(/ AND /g, "##AND##").replace(/ OR /g, "##OR##").replace(/ NOT /g, "##NOT##").replace(/AND /g, "AND##").replace(/OR /g, "OR##").replace(/NOT /g, "NOT##");
            dispText = dispText.includes('"') ? dispText : dispText.replace(/ /g, " AND ");
            dispText = dispText.replace(/##AND##/g, ' AND ').replace(/##OR##/g, ' OR ').replace(/##NOT##/g, ' NOT ').replace(/AND##/g, 'AND ').replace(/OR##/g, 'OR ').replace(/NOT##/g, 'NOT ');
            const countResult = dispText != "" ? numFound + " results for " + dispText : numFound + " results";
            const renderPDF = (pdfpath) => {
                <div>
                    <Document
                        file={pdfpath}
                        onLoadSuccess={this.onDocumentLoadSuccess}
                    >
                        <Page pageNumber={pageNumber} />
                    </Document>
                    <p>Page {pageNumber} of {numPages}</p>
                </div>
            }

            const renderItemsWithSummary = currentItems.map((item, index) => {
                var content = this.getContent(item[1].id).CONTENT;
                var title = this.getTitle(item[1].id) != "" ? this.getTitle(item[1].id) : item[1].title[0];
                var prdid = item[1].productId == null ? 0 : item[1].productId;
                var prddtlid = item[1].productDetailId == null ? 0 : item[1].productDetailId;
                var docId = item[1].fileName == null ? "" : item[1].fileName.replace(/.pdf/g, "");
                var issueText = typeof item[1].issueText != 'undefined' && item[1].issueText != null ? item[1].issueText.includes("/") ? item[1].issueText.split('/')[0].replace(/Issue/g, "").trim() : item[1].issueText.replace(/Issue/g, "").trim() : "";
                var publication = item[1].publication == null ? "" : item[1].publication[0].replace(/ /g, "+");
                var author = item[1].author == null ? " " : item[1].author.join(', ')
                var url = item[1].contentType == "Journal" ? "/JournalsArticle?prddtlid=" + prddtlid + "&volid=0 &issid=0 &prdid=" + prdid
                    : "/ManualChapter?Id=" + prddtlid + "&ProductId=" + prdid;
                var urls = item[1].contentType == "Journal" ? "/JournalArticle/" + publication + "/" + item[1].volume + "." + issueText + "/" + docId
                    : item[1].contentType == "Manual" ? "/ManualChapter/" + publication + "/" + docId : "/EncyclopediaChapter/" + publication + "/" + docId;
                var displayicon = "test.png";
                if (localStorage.getItem('user') != null && localStorage.getItem('usersubscription').length > 0) {
                    var subscription = localStorage.getItem('usersubscription').split(',');
                    var displayicon = subscription.filter(e => e == prddtlid).length == 0 ? "test.png" : "check.png";
                }

                var iniclass = "hide";
                if (typeof content != 'undefined') {
                    if (Object.keys(content).length < 2) {
                        iniclass = "hide";
                    }
                    else {
                        iniclass = "BookBody";
                    }
                }
                return <div key={index} id={item[1].id + "div"} ref={item[1].id + "div"}>
                    {displayicon == "check.png" ?
                        <span CheckMark-tooltip="This content is part of your subscription">
                            <img alt="" src={"/../../images/" + displayicon} style={{ verticalAlign: 'top', position: 'absolute' }} />
                        </span>
                        :
                        <img alt="" src={"/../../images/" + displayicon} style={{ verticalAlign: 'top', position: 'absolute' }} />
                    }
                    <div style={displayicon == "check.png" ? FormatSign : RemoveFormat}>
                        <Link to={urls}>
                            <h4 className="BookHeading" dangerouslySetInnerHTML={{ __html: title }} style={{ marginBottom: '0px' }}>
                                {/*
                     *  <div dangerouslySetInnerHTML={{ __html: title }} onClick={() => { this.showmodal(pdfPath('./' + item[1].id + '.pdf'), item[1].title[0]) }} />
                        <a href={pdfPath('./' + item[1].id + '.pdf')} target="_blank" dangerouslySetInnerHTML={{ __html: item[1].title[0] }} />
                        <a href={'api/Product/RenderPDF?file=' + item[1].fileName} target="_blank" dangerouslySetInnerHTML={{ __html: title }} />
                    */}
                            </h4> </Link>
                        <span><span className="LinkClass">{author}</span>,  <span className="grey-text-on-white-bg"> {item[1].publication + "  (" + new Date(item[1].publicationDate).getUTCFullYear() + ")"} </span></span> </div>
                    {
                        (typeof content != 'undefined') ?
                            Object.keys(content).map((num, index) => {
                                if (index < 2) {
                                    return <p style={displayicon == "check.png" ? FormatText : null} dangerouslySetInnerHTML={{ __html: "..." + content[num] + "..." }} className="searchresultText" />
                                }
                                else {
                                    return <p style={displayicon == "check.png" ? FormatText : null} dangerouslySetInnerHTML={{ __html: "..." + content[num] + "..." }} className="hide" />
                                }
                            }) : ""
                    }
                    <span className="float-right">
                        <span id={item[1].id + "prev"} ref={item[1].id + "prev"} className="hide" style={{ padding: '0px 7px', cursor: 'pointer' }} onClick={this.handlePrev} slot="0"><i className="oi oi-chevron-left font"></i> Prev</span>
                        <span id={item[1].id + "next"} ref={item[1].id + "next"} className={iniclass} style={{ padding: '0px 7px', cursor: 'pointer' }} onClick={this.handleNext} slot="1">Next <i className="oi oi-chevron-right font"></i> </span>
                    </span>
                    <hr className="hrborder"></hr>

                </div>
            })

            const renderItemsNoSummary = currentItems.map((item, index) => {
                var content = this.getContent(item[1].id).CONTENT;
                var title = this.getTitle(item[1].id) != "" ? this.getTitle(item[1].id) : item[1].title[0];
                var prdid = item[1].productId == null ? 0 : item[1].productId;
                var prddtlid = item[1].productDetailId == null ? 0 : item[1].productDetailId;
                var docId = item[1].fileName == null ? "" : item[1].fileName.replace(/.pdf/g, "");
                var issueText = typeof item[1].issueText != 'undefined' && item[1].issueText != null ? item[1].issueText.includes("/") ? item[1].issueText.split('/')[0].replace(/Issue/g, "").trim() : item[1].issueText.replace(/Issue/g, "").trim() : "";
                var publication = item[1].publication == null ? "" : item[1].publication[0].replace(/ /g, "+");
                var author = item[1].author == null ? " " : item[1].author.join(', ')
                var url = item[1].contentType == "Journal" ? "/JournalsArticle?prddtlid=" + prddtlid + "&volid=0 &issid=0 &prdid=" + prdid
                    : "/ManualChapter?Id=" + prddtlid + "&ProductId=" + prdid;
                var urls = item[1].contentType == "Journal" ? "/JournalArticle/" + publication + "/" + item[1].volume + "." + issueText + "/" + docId
                    : item[1].contentType == "Manual" ? "/ManualChapter/" + publication + "/" + docId : "/EncyclopediaChapter/" + publication + "/" + docId;

                var displayicon = "test.png";
                if (localStorage.getItem('user') != null && localStorage.getItem('usersubscription').length > 0) {
                    var subscription = localStorage.getItem('usersubscription').split(',');
                    var displayicon = subscription.filter(e => e == item[1].id).length == 0 ? "test.png" : "check.png";
                }

                return <div key={index} id={item[1].id + "div"} ref={item[1].id + "div"}>
                    {displayicon == "check.png" ?
                        <span CheckMark-tooltip="This content is part of your subscription">
                            <img alt="" src={"/../../images/" + displayicon} style={{ verticalAlign: 'top', position: 'absolute' }} />
                        </span>
                        :
                        <img alt="" src={"/../../images/" + displayicon} style={{ verticalAlign: 'top', position: 'absolute' }} />
                    }
                    <div style={displayicon == "check.png" ? FormatSign : RemoveFormat}>
                        <Link to={urls}>
                            <h4 className="BookHeading" dangerouslySetInnerHTML={{ __html: title }} style={{ marginBottom: '0px' }}>
                                {//<Redirect to={"/JournalPublication?id=" + item[1].productDetailId} dangerouslySetInnerHTML={{ __html: title }} />
                                    //<a href={'api/Product/RenderPDF?file=' + item[1].fileName} target="_blank" dangerouslySetInnerHTML={{ __html: title }} />
                                }
                            </h4>
                        </Link>
                        <span><span className="LinkClass">{author}</span>,  <span className="grey-text-on-white-bg"> {item[1].publication + "  (" + new Date(item[1].publicationDate).getUTCFullYear() + ")"} </span></span> </div>
                    <hr className="hrborder"></hr>
                </div>
            })

            //this.setState({ ResultCount: items.length + " results for " + "\"" + this.state.parameters.searchText + "\"" });
            this.state.contentAll = 0;
            var ConTypeSorted = new Array();
            if (facetfields != null && facetfields.contenttype != null) {
                Object.entries(facetfields.contenttype).map((item, index) => {

                    let element = this.state.parameters.ContentType.indexOf(item[1].key);
                    let isChecked = false;

                    if (element != -1) {
                        isChecked = true;
                    }
                    else {
                        isChecked = false;
                    }
                    var singleItem = { name: item[1].key, count: item[1].value, checked: isChecked };
                    ConTypeSorted.push(singleItem);
                })
            }
            ConTypeSorted.sort(function (a, b) { return b.checked - a.checked });
            const renderContentType = facetfields.contenttype != null && Object.entries(ConTypeSorted).map((item, index) => {

                this.state.contentAll = Number(this.state.contentAll) + Number(item[1].count);

                //let element = arr.find(o => o.Value == item[1].key);
                //let element = this.state.SelectedSearchValue.indexOf(item[1].key);               

                if (preSearchParameters.ContentType == "" && item[1].name != "Encyclopedia") {
                    return <div className="square">
                        <input type="checkbox" id={item[1].name} defaultChecked={item[1].checked} onChange={this.handleContentTypeRefineSerach} checked={item[1].checked} />
                        <label htmlFor={item[1].name}></label>
                        <span className="Searchlabel"> {item[1].name} ({item[1].count}) </span>
                        <br></br><br></br>
                    </div>
                }
                else {
                    if (preSearchParameters.ContentType == item[1].name) {
                        return <div className="square">
                            <input type="checkbox" id={item[1].name} defaultChecked={item[1].checked} onChange={this.handleContentTypeRefineSerach} checked={item[1].checked} />
                            <label htmlFor={item[1].name}></label>
                            <span className="Searchlabel"> {item[1].name} ({item[1].count}) </span>
                            <br></br><br></br>
                        </div>
                    }
                }
            })




            //if (this.state.facetfields != null && this.state.facetfields.contenttype != null)
            //{
            //    this.state.contentAll = 0;
            //    this.state.contResult= Object.entries(this.state.facetfields.contenttype).map((item, index) => {

            //        this.state.contentAll = this.state.contentAll + item[1].value;

            //        var arr = this.state.SelectedSearchValue.split(',')

            //            let element = arr[item[1].key]
            //            let isChecked = false;
            //            if (element != null) {
            //                isChecked = true;
            //            }


            //        return <div className="square">

            //            <input type="checkbox" id={item[1].key} value={item[1].value} defaultChecked={isChecked} onClick={this.handleContentTypeChange}  />
            //            <label htmlFor={item[1].key}></label>
            //                    <span className="Searchlabel">
            //                    {item[1].key} ({item[1].value})
            //                    </span> <br /><br />
            //                </div>
            //    })     

            //}

            //publications
            var pubSorted = new Array();
            if (this.state.facetfields != null && this.state.facetfields.publications != null) {
                this.state.publicationResult = Object.entries(this.state.facetfields.publications).map((item, index) => {

                    let element = this.state.parameters.Publication.indexOf(item[1].key);
                    let isChecked = false;

                    if (element != -1) {
                        isChecked = true;
                    }
                    else {
                        isChecked = false;
                    }

                    var singleItem = { name: item[1].key, count: item[1].value, checked: isChecked };
                    pubSorted.push(singleItem);
                })
            }
            pubSorted.sort(function (a, b) { return b.checked - a.checked });
            if (this.state.facetfields != null && this.state.facetfields.publications != null) {
                this.state.publicationResult = Object.entries(pubSorted).map((item, index) => {

                    let iniclass = "hide";
                    if (index < 4) {
                        iniclass = "square";
                    }
                    else {
                        iniclass = "hide";
                    }

                    return <div className={iniclass}>
                        <input type="checkbox" id={item[1].name} defaultChecked={item[1].checked} onChange={this.handlePublicationRefineSerach} checked={item[1].checked} />
                        <label htmlFor={item[1].name}></label>
                        <span className="Searchlabel">
                            {item[1].name} ({item[1].count})
                            </span> <br /><br />
                    </div>
                })
            }

            //practiceareas
            var praAreaSorted = new Array();
            if (this.state.facetfields != null && this.state.facetfields.practiceareas != null) {
                this.state.practiceareaResult = Object.entries(this.state.facetfields.practiceareas).map((item, index) => {

                    let element = this.state.SelectedPracticeAreaValue.indexOf(item[1].key);
                    let isChecked = false;

                    if (element != -1) {
                        isChecked = true;
                    }
                    else {
                        isChecked = false;
                    }

                    var singleItem = { name: item[1].key, count: item[1].value, checked: isChecked };
                    praAreaSorted.push(singleItem);
                })
            }

            praAreaSorted.sort(function (a, b) { return b.checked - a.checked });
            if (this.state.facetfields != null && this.state.facetfields.practiceareas != null) {
                this.state.practiceareaResult = Object.entries(praAreaSorted).map((item, index) => {

                    let cssclass = "hide";

                    if (index < 4) {
                        cssclass = "square";
                    }
                    else {
                        cssclass = "hide";
                    }

                    return <div className={cssclass}>

                        <input type="checkbox" id={item[1].name} defaultChecked={item[1].checked} onChange={this.handlePracticeAreaRefineSerach} checked={item[1].checked} />
                        <label htmlFor={item[1].name}></label>
                        <span className="Searchlabel"> {item[1].name} ({item[1].count}) </span>
                        <br /><br />
                    </div>
                })
            }

            //Author
            var authorSorted = new Array();
            if (this.state.facetfields != null && this.state.facetfields.authors != null) {
                this.state.authorResult = Object.entries(this.state.facetfields.authors).map((item, index) => {
                    let element = this.state.parameters.Author.indexOf(item[1].key);
                    let isChecked = false;

                    if (element != -1) {
                        isChecked = true;
                    }
                    else {
                        isChecked = false;
                    }

                    var singleItem = { name: item[1].key, count: item[1].value, checked: isChecked };
                    authorSorted.push(singleItem);
                })
            }

            //sample.sort((a, b) => a.count.localeCompare(b.count));
            //sample.sort(function (a, b) { return (a.checked > b.checked) ? 1 : ((b.checked > a.checked) ? -1 : 0); });
            authorSorted.sort(function (a, b) { return b.checked - a.checked });
            if (this.state.facetfields != null && this.state.facetfields.authors != null) {
                //this.state.authorsAll = 0;
                this.state.authorResult = Object.entries(authorSorted).map((item, index) => {

                    let cssclass = "hide";
                    if (index < 4) {
                        cssclass = "square";
                    }
                    else {
                        cssclass = "hide";
                    }

                    return <div className={cssclass}>

                        <input type="checkbox" id={item[1].name} defaultChecked={item[1].checked} onChange={this.handleAuthorRefineSerach} checked={item[1].checked} />
                        <label htmlFor={item[1].name}></label>
                        <span className="Searchlabel"> {item[1].name} ({item[1].count})
                            </span> <br /><br />
                    </div>
                })
            }

            if (this.state.facetfields != null && this.state.facetfields.publicationdate != null) {

                this.state.publicationAll = 0;

                // Logic for Last 30 Days
                var startDate30D = new Date();
                startDate30D.setDate(startDate30D.getDate() - 30);
                this.state.Last30DCount = this.FindCountForPublicationDateWise(startDate30D);

                // Logic for Last 3 month
                var startDate3M = new Date();
                startDate3M.setMonth(startDate3M.getMonth() - 3);
                this.state.Last3MCount = this.FindCountForPublicationDateWise(startDate3M);

                // Logic for Last 1 Year
                var startDate1Y = new Date();
                startDate1Y.setFullYear(startDate1Y.getFullYear() - 1);
                this.state.Last1YCount = this.FindCountForPublicationDateWise(startDate1Y);

                // Logic for Last 3 Year
                var startDate3Y = new Date();
                startDate3Y.setFullYear(startDate3Y.getFullYear() - 3);
                this.state.Last3YCount = this.FindCountForPublicationDateWise(startDate3Y);

                //alert('Last 30 Days : ' + this.state.Last30DCount + '\n Last3 Month : ' + this.state.Last3MCount + '\n    Last1 Year : ' + this.state.Last3YCount + '\n  Last 3 Year : ' + this.state.Last3YCount);
                // Logic for Last 3 Year
                var startDateAll = new Date();
                startDateAll.setFullYear(startDate3Y.getFullYear() - 100);
                this.state.publicationAll = this.FindCountForPublicationDateWise(startDateAll);

                this.state.Last30DChecked = false;
                this.state.Last3MChecked = false;
                this.state.Last1YChecked = false;
                this.state.Last3YChecked = false;
                this.state.pubdurAllChecked = false;
                //this.state.pubdurCPPChecked = false;
                if (this.state.parameters.PublicationDuration == "" || this.state.parameters.PublicationDuration == "All") {
                    this.state.pubdurAllChecked = true;
                    this.state.pubdurCPPChecked = false;
                }
                else if (this.state.parameters.PublicationDuration == "30D") {
                    //this.setState({ Last30DChecked: true });
                    this.state.Last30DChecked = true;
                    this.state.pubdurCPPChecked = false;
                }
                else if (this.state.parameters.PublicationDuration == "3M") {
                    this.state.Last3MChecked = true;
                    this.state.pubdurCPPChecked = false;
                }
                else if (this.state.parameters.PublicationDuration == "1Y") {
                    this.state.Last1YChecked = true;
                    this.state.pubdurCPPChecked = false;
                }
                else if (this.state.parameters.PublicationDuration == "3Y") {
                    this.state.Last3YChecked = true;
                    this.state.pubdurCPPChecked = false;
                }
                else if (this.state.parameters.PublicationDuration == "CPP") {
                    this.state.pubdurCPPChecked = true;
                }

                //show/Hide logic based on Presearch filter
                //if (preSearchParameters.PublicationDuration == "") { }
                if (preSearchParameters.PublicationDuration == "30D") {
                    this.state.Last30DShow = true;
                    this.state.Last3MShow = false;
                    this.state.Last1YShow = false;
                    this.state.Last3YShow = false;
                    //this.state.AllDateShow = false;
                    this.state.CPPShow = false;
                }
                else if (preSearchParameters.PublicationDuration == "3M") {
                    this.state.Last3MShow = true;
                    this.state.Last30DShow = false;
                    this.state.Last1YShow = false;
                    this.state.Last3YShow = false;
                    //this.state.AllDateShow = false;
                    this.state.CPPShow = false;
                }
                else if (preSearchParameters.PublicationDuration == "1Y") {
                    //this.setState({ Last1YShow: true, Last30DShow: false, Last3MShow: false, Last3YShow : false  });
                    this.state.Last1YShow = true;
                    this.state.Last30DShow = false;
                    this.state.Last3MShow = false;
                    this.state.Last3YShow = false;
                    //this.state.AllDateShow = false;
                    this.state.CPPShow = false;
                }
                else if (preSearchParameters.PublicationDuration == "3Y") {
                    this.state.Last3YShow = true;
                    this.state.Last30DShow = false;
                    this.state.Last3MShow = false;
                    this.state.Last1YShow = false;
                    //this.state.AllDateShow = false;
                    this.state.CPPShow = false;
                }
                else if (preSearchParameters.PublicationDuration == "CPP") {
                    this.state.Last3YShow = false;
                    this.state.Last30DShow = false;
                    this.state.Last3MShow = false;
                    this.state.Last1YShow = false;
                    //this.state.AllDateShow = false;
                    this.state.CPPShow = true;
                }
                else {
                    this.state.Last30DShow = true;
                    this.state.Last3MShow = true;
                    this.state.Last1YShow = true;
                    this.state.Last3YShow = true;
                    this.state.AllDateShow = true;
                    this.state.CPPShow = true;
                }

            }

            if (this.state.facetfields != null && this.state.facetfields.title != null) {
                var result = this.state.facetfields.title.filter(d => {
                    return d.key == this.state.parameters.searchText
                });

                if (result != null && result != 'undefined' && result.length > 0) {
                    this.state.SearchInTitleCount = result[0].value;
                }
                else {
                    this.state.SearchInTitleCount = 0;
                }

            }


            /// Logic for displaying total pages ///
            const page = [];
            page.push(1);
            const TotalPageNum = Math.ceil(numFound / itemsPerPage);
            const renderTotalPageNum = page.map(number => {
                return (
                    TotalPageNum
                );
            });
            var FirstPage = this.refs["FirstPageDiv"];
            var PrevPage = this.refs["PrevPageDiv"];
            var LastPage = this.refs["LastPageDiv"];
            var NextPage = this.refs["NextPageDiv"];

            if (renderTotalPageNum == 1) {
                //var FirstPage = this.refs["FirstPageDiv"];
                //var PrevPage = this.refs["PrevPageDiv"];
                //var LastPage = this.refs["LastPageDiv"];
                //var NextPage = this.refs["NextPageDiv"];  
                if (FirstPage != undefined && PrevPage != undefined && LastPage != undefined && NextPage != undefined) {
                    FirstPage.className = "hide";
                    PrevPage.className = "hide";
                    LastPage.className = "hide";
                    NextPage.className = "hide";
                }
            }
            if (this.state.parameters.PageNo == 1 && FirstPage != undefined && PrevPage != undefined) {
                FirstPage.className = "hide";
                PrevPage.className = "hide";
            }
            if (this.state.parameters.PageNo == Math.ceil(numFound / itemsPerPage) && LastPage != undefined && NextPage != undefined) {
                LastPage.className = "hide";
                NextPage.className = "hide";
            }


            return (
                <DocumentMeta {...meta}>
                <div>
                    <div className="row">
                        <div className="col-lg-7">
                        </div>
                        <div className="col-lg-2">
                            <div className="custom-control custom-radio col">
                                <label className="radiocontainer">
                                    <input type="radio" name="searchradio" value="newsearch" onChange={this.searchWithIn} />
                                    <span className="checkRadiomark"></span>
                                </label>
                                <span className="Searchlabel">New search</span>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="custom-control custom-radio col">
                                <label className="radiocontainer">
                                    <input type="radio" name="searchradio" value="existingsearch" checked="true" onChange={this.searchWithIn} />
                                    <span className="checkRadiomark"></span>
                                </label>
                                <span className="Searchlabel">Search within current results</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="row">
                            <div className="col-lg-9">
                                <h3 className="LawHeader TitlePadding">{countResult} </h3>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">

                            </div>
                            <div className="column Rescolumn">
                                <span className="float-left" style={{ margin: '10px 0px' }}>Sort</span>
                                <Form.Group controlId="formpub" style={{ display: 'inline-block', padding: '0px 15px' }}>
                                    <Form.Control as="select" onChange={this.SetSorting} value={this.state.SortBy} className="drp">
                                        <option>Relevancy</option>
                                        <option>Publication Date</option>
                                    </Form.Control>
                                </Form.Group>
                            </div>
                            <div className="col-lg-1 MaxwidthZero">

                            </div>
                            <div className="column">
                                <span className="float-left" style={{ margin: '10px 0px' }}>Display</span>
                                <Form.Group controlId="formpub" style={{ display: 'inline-block', padding: '0px 15px' }}>
                                    <Form.Control as="select" onChange={this.SetSummary} value={this.state.DisplayStatus} className="drp">
                                        <option>Summary</option>
                                        <option>No Summary</option>
                                    </Form.Control>
                                </Form.Group>
                            </div>
                            <div className="col-lg-1" style={{ display: 'none' }}>
                                <div className="Searchp Hoverclass" onClick={this.CopyURL}>URL</div>
                            </div>

                            <div className="col-lg-1 TitlePadding">
                                <p>
                                    <CSVLink ref={this.csvLink} Searchdata-tooltip="Export results to CSV" filename={"Search_Result_" + new Date().getDate() + "_" + (new Date().getMonth() + 1) + "_" + new Date().getFullYear() + ".csv"} data={this.state.csvData}>
                                        <img className="CSVFormat" onClick={this.DownloadCSV} alt="" src="/../../images/export-csv-dafault.svg" />
                                    </CSVLink>
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 TitlePadding">
                                <p className="searchpanel">
                                    <span className="searchheading" style={{ margin: '0% 5%' }}> Content type</span>
                                    <span><i className="fa fa-caret-up searchcaret"></i></span>
                                </p>
                                <p className="searchscroll scrollbar" id="style-2">
                                    <div className="force-overflow" ref="ContentType">
                                        {/*
                                    <div className="square">

                                        <input type="checkbox" id="AllContent" onClick={this.handleContentTypeRefineSerach} />
                                        <label htmlFor="AllContent"></label><span className="Searchlabel">
                                        All({this.state.contentAll})</span></div>
                                <br></br>
                                */}
                                        {renderContentType}


                                    </div>
                                </p>
                                <p className="searchpanel">
                                    <span className="searchheading" style={{ margin: '0% 5%' }}> Publication</span>
                                    <span><i className="fa fa-caret-up searchcaret"></i></span>
                                </p>

                                <p className="searchscroll scrollbar" id="style-2" ref="Publication">
                                    {this.state.publicationResult}
                                </p>

                                <hr className=""></hr>
                                {this.state.publicationResult.length > 4 ?
                                    <p className="searchscroll">
                                        <span className="LinkClass" onClick={(e) => this.showMore("Publication", e)} style={{ cursor: 'pointer' }}>Show more</span>

                                    </p>
                                    :
                                    null
                                }
                                <p className="searchpanel">
                                    <span className="searchheading" style={{ margin: '0% 5%' }}> Author</span>
                                    <span><i className="fa fa-caret-up searchcaret"></i></span>
                                </p>
                                <p className="searchscroll scrollbar" id="style-2" ref="Author">
                                    {this.state.authorResult}

                                </p>
                                <hr className=""></hr>
                                {this.state.authorResult.length > 4 ?
                                    <p className="searchscroll">
                                        <span className="LinkClass" onClick={(e) => this.showMore("Author", e)} style={{ cursor: 'pointer' }}>Show more</span>
                                    </p>
                                    : null
                                }

                                <p className="searchpanel">
                                    <span className="searchheading" style={{ margin: '0% 5%' }}>Publication Date</span>
                                    <span><i className="fa fa-caret-up searchcaret"></i></span>
                                </p>
                                <p className="searchscroll" ref="PublicationDuration">
                                    {this.state.AllDateShow == true ?
                                        <div className="custom-control custom-radio col">
                                            <label className="radiocontainer"><input type="radio" name="radio" onClick={this.handlePublicationDurationRefineSerach} value="All" checked={this.state.pubdurAllChecked} />
                                                <span className="checkRadiomark"></span></label>
                                            <span className="Searchlabel">All time</span>
                                            {//<span className="Searchlabel">All time({this.state.publicationAll})</span>
                                            }
                                        </div>
                                        : null
                                    }

                                    {this.state.Last30DShow == true ?
                                        <div className="custom-control custom-radio col">
                                            <label className="radiocontainer"><input type="radio" onClick={this.handlePublicationDurationRefineSerach} name="radio" value="30D" checked={this.state.Last30DChecked} />
                                                <span className="checkRadiomark"></span></label>
                                            <span className="Searchlabel">Last 30 days ({this.state.Last30DCount})</span>
                                        </div>
                                        : null
                                    }

                                    {this.state.Last3MShow == true ?
                                        <div className="custom-control custom-radio col">
                                            <label className="radiocontainer"><input type="radio" name="radio" onClick={this.handlePublicationDurationRefineSerach} value="3M" checked={this.state.Last3MChecked} />
                                                <span className="checkRadiomark"></span></label>
                                            <span className="Searchlabel">Last 3 months ({this.state.Last3MCount})</span>
                                        </div>
                                        : null
                                    }

                                    {this.state.Last1YShow == true ?
                                        <div className="custom-control custom-radio col">
                                            <label className="radiocontainer"><input type="radio" name="radio" onClick={this.handlePublicationDurationRefineSerach} value="1Y" checked={this.state.Last1YChecked} />
                                                <span className="checkRadiomark"></span></label>
                                            <span className="Searchlabel">Last 1 year ({this.state.Last1YCount})</span>
                                        </div>
                                        : null
                                    }

                                    {this.state.Last3YShow == true ?
                                        <div className="custom-control custom-radio col">
                                            <label className="radiocontainer"><input type="radio" name="radio" onClick={this.handlePublicationDurationRefineSerach} value="3Y" checked={this.state.Last3YChecked} />
                                                <span className="checkRadiomark"></span></label>
                                            <span className="Searchlabel">Last 3 years ({this.state.Last3YCount})</span>
                                        </div>
                                        : null
                                    }

                                    {this.state.CPPShow == true ?
                                        <div className="custom-control custom-radio col">
                                            <label className="radiocontainer"><input type="radio" name="radio" onClick={this.handleCPPCheck} value="CPP" checked={this.state.pubdurCPPChecked} />
                                                <span className="checkRadiomark"></span></label>
                                            <span className="Searchlabel">Choose precise period</span>
                                            <div className="row">
                                                {this.state.ShowDatePicker ?
                                                    <span className="Searchlabel"> Start Date :
                                                        <DatePicker
                                                            selected={this.state.StartDate}
                                                            onChange={this.handleStartDateChange}
                                                        />
                                                    </span>
                                                    : null}
                                            </div>
                                            <div className="row">
                                                {this.state.ShowDatePicker ?
                                                    <span className="Searchlabel"> End Date :
                                                        <DatePicker
                                                            selected={this.state.EndDate}
                                                            onChange={this.handleEndDateChange}
                                                        />
                                                    </span>
                                                    : null}
                                            </div>
                                        </div>
                                        : null
                                    }

                                </p>
                                <p className="searchpanel" style={{ display: 'none' }}>
                                    <span className="searchheading" style={{ margin: '0% 5%' }}>Subscribed content</span>
                                    <span><i className="fa fa-caret-up searchcaret"></i></span>
                                </p>
                                <p className="searchscroll" style={{ display: 'none' }}>
                                    <div className="square">
                                        <input type="checkbox" id="CurrSubscribed" />
                                        <label htmlFor="CurrSubscribed"></label>
                                        <span className="Searchlabel">Currently subscribed (101)</span>
                                    </div>
                                </p>

                                <p className="searchpanel" style={{ display: 'none' }}>
                                    <span className="searchheading" style={{ margin: '0% 5%' }}>Words in title</span>
                                    <span>
                                        <i className="fa fa-caret-up searchcaret"></i>
                                    </span>
                                </p>
                                <p className="searchscroll" style={{ display: 'none' }}>
                                    <div className="square">
                                        <input type="checkbox" id="wordIntitle" onChange={this.handleSearchWordIntitle} />
                                        <label htmlFor="wordIntitle"></label>
                                        <span className="Searchlabel">
                                            Search terms in title ({this.state.SearchInTitleCount})
                                    </span>
                                    </div>
                                </p>
                                <p className="searchpanel">
                                    <span className="searchheading" style={{ margin: '0% 5%' }}>Practice area of publication</span>
                                    <span><i className="fa fa-caret-up searchcaret"></i></span>
                                </p>
                                <p className="searchscroll scrollbar" id="style-2" ref="PracticeArea">
                                    {this.state.practiceareaResult}
                                </p>
                                <hr></hr>
                                {this.state.practiceareaResult.length > 4 ?
                                    <p className="searchscroll searchbottom">
                                        <span className="LinkClass" onClick={(e) => this.showMore("PracticeArea", e)} style={{ cursor: 'pointer' }}>Show more</span>
                                    </p>
                                    : null
                                }
                            </div>

                            <div className="col-lg-4 TitlePadding" style={{ display: 'none' }}>
                                <p className="searchpanel">
                                    <span className="searchheading" style={{ margin: '0% 5%' }}> Content type</span>
                                    <span><i className="fa fa-caret-up searchcaret"></i></span>
                                </p>
                                <p className="searchsubmenu">
                                    <div className="square">
                                        <input type="checkbox" id="All" />
                                        <label htmlFor="All"></label><span className="Searchlabel">
                                            All (258)</span></div>
                                    <br></br>
                                    <div className="square">
                                        <input type="checkbox" id="Journals" />
                                        <label htmlFor="Journals"></label><span className="Searchlabel">
                                            Journals (15)</span></div>
                                    <br></br>
                                    <div className="square">
                                        <input type="checkbox" id="Encyclopedias" />
                                        <label htmlFor="Encyclopedias"></label><span className="Searchlabel">
                                            Encyclopaedias (43)</span></div>
                                    <br></br>
                                    <div className="square">
                                        <input type="checkbox" id="Manuals" />
                                        <label htmlFor="Manuals"></label><span className="Searchlabel">
                                            Manuals (110)</span></div>
                                </p>
                                <p className="searchpanel">
                                    <span className="searchheading" style={{ margin: '0% 5%' }}> Publication</span>
                                    <span><i className="fa fa-caret-up searchcaret"></i></span>
                                </p>

                                <p className="searchscroll scrollbar" id="style-2">
                                    <div className="force-overflow">
                                        <div className="square">
                                            <input type="checkbox" id="All" />
                                            <label htmlFor="All"></label><span className="Searchlabel">
                                                All (258)</span></div>
                                        <br></br>
                                        <div className="square">
                                            <input type="checkbox" id="Journals" />
                                            <label htmlFor="Journals"></label><span className="Searchlabel">
                                                Journals (15)</span></div>
                                        <br></br>
                                        <div className="square">
                                            <input type="checkbox" id="Encyclopedias" />
                                            <label htmlFor="Encyclopedias"></label><span className="Searchlabel">
                                                Encyclopaedias (43)</span></div>
                                        <br></br>
                                        <div className="square">
                                            <input type="checkbox" id="Manuals" />
                                            <label htmlFor="Manuals"></label><span className="Searchlabel">
                                                Manuals (110)</span>
                                        </div>
                                    </div>
                                </p>
                                <hr className=""></hr>
                                <p className="searchscroll">

                                    <span className="LinkClass" style={{ cursor: 'pointer' }}>Show more</span>
                                </p>
                                <p className="searchpanel">
                                    <span className="searchheading" style={{ margin: '0% 5%' }}> Author</span>
                                    <span><i className="fa fa-caret-up searchcaret"></i></span>
                                </p>
                                <p className="searchscroll scrollbar" id="style-2">
                                    <div className="force-overflow">
                                        <div className="square">
                                            <input type="checkbox" id="All" />
                                            <label htmlFor="All"></label><span className="Searchlabel">
                                                All (258)</span></div>
                                        <br></br>
                                        <div className="square">
                                            <input type="checkbox" id="Journals" />
                                            <label htmlFor="Journals"></label><span className="Searchlabel">
                                                Journals (15)</span></div>
                                        <br></br>
                                        <div className="square">
                                            <input type="checkbox" id="Encyclopedias" />
                                            <label htmlFor="Encyclopedias"></label><span className="Searchlabel">
                                                Encyclopaedias (43)</span></div>
                                        <br></br>
                                        <div className="square">
                                            <input type="checkbox" id="Manuals" />
                                            <label htmlFor="Manuals"></label><span className="Searchlabel">
                                                Manuals (110)</span>
                                        </div>
                                    </div>

                                </p>
                                <hr className=""></hr>
                                <p className="searchscroll">
                                    <span className="LinkClass" style={{ cursor: 'pointer' }}>Show more</span>
                                </p>


                                <p className="searchpanel">
                                    <span className="searchheading" style={{ margin: '0% 5%' }}>Publication Date</span>
                                    <span><i className="fa fa-caret-up searchcaret"></i></span>
                                </p>
                                <p className="searchscroll">

                                    <div className="custom-control custom-radio col">
                                        <label className="radiocontainer"><input type="radio" name="radio" />
                                            <span className="checkRadiomark"></span></label>
                                        <span className="Searchlabel">All time(115)</span>
                                    </div>
                                    <div className="custom-control custom-radio col">
                                        <label className="radiocontainer"><input type="radio" name="radio" />
                                            <span className="checkRadiomark"></span></label>
                                        <span className="Searchlabel">Last 30 days (82)</span>
                                    </div>
                                    <div className="custom-control custom-radio col">
                                        <label className="radiocontainer"><input type="radio" name="radio" />
                                            <span className="checkRadiomark"></span></label>
                                        <span className="Searchlabel">Last 3 months (22)</span>
                                    </div>
                                    <div className="custom-control custom-radio col">
                                        <label className="radiocontainer"><input type="radio" name="radio" />
                                            <span className="checkRadiomark"></span></label>
                                        <span className="Searchlabel">Last 1 year (45)</span>
                                    </div>
                                    <div className="custom-control custom-radio col">
                                        <label className="radiocontainer"><input type="radio" name="radio" />
                                            <span className="checkRadiomark"></span></label>
                                        <span className="Searchlabel">Last 3 years (67)</span>
                                    </div>
                                    <div className="custom-control custom-radio col">
                                        <label className="radiocontainer"><input type="radio" name="radio" />
                                            <span className="checkRadiomark"></span></label>
                                        <span className="Searchlabel">Choose precise period</span>
                                    </div>
                                </p>
                                <p className="searchpanel">
                                    <span className="searchheading" style={{ margin: '0% 5%' }}>Subscribed content</span>
                                    <span><i className="fa fa-caret-up searchcaret"></i></span>
                                </p>
                                <p className="searchscroll">
                                    <div className="square">
                                        <input type="checkbox" id="Manuals" />
                                        <label htmlFor="Manuals"></label>
                                        <span className="Searchlabel">Currently subscribed (101)</span>
                                    </div>
                                </p>

                                <p className="searchpanel">
                                    <span className="searchheading" style={{ margin: '0% 5%' }}>Words in title</span>
                                    <span>
                                        <i className="fa fa-caret-up searchcaret"></i>
                                    </span>
                                </p>
                                <p className="searchscroll">
                                    <div className="square">
                                        <input type="checkbox" id="Manuals" />
                                        <label htmlFor="Manuals"></label>
                                        <span className="Searchlabel">
                                            Search terms in title (98)
                                    </span>
                                    </div>
                                </p>
                                <p className="searchpanel">
                                    <span className="searchheading" style={{ margin: '0% 5%' }}>Practice area of publication</span>
                                    <span><i className="fa fa-caret-up searchcaret"></i></span>
                                </p>
                                <p className="searchscroll scrollbar" id="style-2">
                                    <div className="force-overflow">
                                        <div className="square">
                                            <input type="checkbox" id="All" />
                                            <label htmlFor="All"></label>
                                            <span className="Searchlabel">All (258)</span>
                                        </div>
                                        <br></br>
                                        <div className="square">
                                            <input type="checkbox" id="Journals" />
                                            <label htmlFor="Journals"></label>
                                            <span className="Searchlabel">Journals (15)</span>
                                        </div>
                                        <br></br>
                                        <div className="square">
                                            <input type="checkbox" id="Encyclopedias" />
                                            <label htmlFor="Encyclopedias"></label>
                                            <span className="Searchlabel">Encyclopaedias (43)</span>
                                        </div>
                                        <br></br>
                                        <div className="square">
                                            <input type="checkbox" id="Manuals" />
                                            <label htmlFor="Manuals"></label>
                                            <span className="Searchlabel">Manuals (110)</span>
                                        </div>
                                    </div>
                                </p>
                                <hr></hr>
                                <p className="searchscroll searchbottom">
                                    <span className="LinkClass" style={{ cursor: 'pointer' }}>Show more</span>
                                </p>
                            </div>

                            {this.state.DisplayWithSummary ?
                                <div className="col-lg-8">
                                    <div>
                                        {renderItemsWithSummary}
                                    </div>
                                </div> :
                                <div className="col-lg-8">
                                    <div>
                                        {renderItemsNoSummary}
                                    </div>
                                </div>}
                        </div>
                        <div className="row">

                            <div className="col-lg-5">
                            </div>
                            <div className="col-lg-1">
                                <span className="float-right" style={{ margin: '16% 0%' }}>{this.state.currentPage}/{renderTotalPageNum}</span>
                            </div>

                            <div className="col-lg-1" onClick={this.handleFirstPage} ref="FirstPageDiv">
                                <p className="Searchp Hoverclass">First</p>
                            </div>
                            <div className="col-lg-1" onClick={this.handlePrevPage} id="0" ref="PrevPageDiv">
                                <p className="Searchp Hoverclass" style={{ width: '90px' }}>Prev
                                <i className="oi oi-chevron-left" style={{ padding: '0px 7px', top: '2px' }}></i></p>
                            </div>
                            <div className="col-lg-1" onClick={this.handleNextPage} id="1" ref="NextPageDiv">
                                <p className="Searchp Hoverclass" style={{ width: '100px' }}>Next
                                <i className="oi oi-chevron-right" style={{ padding: '0px 7px', top: '2px' }}></i></p>
                            </div>
                            <div className="col-lg-1" onClick={this.handleLastPage} ref="LastPageDiv">
                                <p className="Searchp Hoverclass">Last</p>
                            </div>

                            <div className="col-lg-2">
                                <span className="float-left" style={{ margin: '5% 0%' }}>Results per <br></br>page</span>

                                <Form.Group controlId="formpub">
                                    <Form.Control as="select" onChange={this.SetNumOfRecord} className="drp float-right" value={this.state.itemsPerPage} style={{ width: '80px' }}>
                                        <option>25</option>
                                        <option>50</option>
                                        <option>75</option>
                                        <option>100</option>
                                    </Form.Control>
                                </Form.Group>



                            </div>
                        </div>
                        <div className="White">
                        </div>
                    </div>
                    {
                        this.state.showPopover ?
                            <ButtonToolbar >

                                <Overlay
                                    show={this.state.showPopover}
                                    target={this.state.target}
                                    placement="bottom"
                                    container={this}
                                    containerPadding={20}
                                    trigger="focus" 
                                >
                                    <Popover className="SearchPopup" id="popover-url" style={{ marginTop: '2%' }} trigger="focus">
                                        <div >
                                            <button type="button" className="close" data-dismiss="popover" aria-hidden="true"
                                                onClick={() => this.setState({ showPopover: false })}>
                                                &times;</button>
                                        </div>
                                        <div className="col-lg-8">{this.state.URLText}</div>

                                    </Popover>
                                </Overlay>
                            </ButtonToolbar>
                            : null
                    }
                </div>
                </DocumentMeta >

            );
        }
    }
}
export default SearchContent;


// WEBPACK FOOTER //
// ./src/components/Home/SearchContent.jsx